const e = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle stroke="#DDD" stroke-width=".8" cx="16" cy="16" r="15.6" />
        <path
            d="M14.365 23.556v-6.893H12v-2.686h2.365v-1.984c0-2.298 1.432-3.549 3.522-3.549 1.001 0 1.862.072 2.113.105v2.403h-1.452c-1.134 0-1.354.535-1.354 1.313v1.714h2.709l-.352 2.693h-2.358v6.884h-2.828z"
            fill="#007AF8" />
    </g>
</svg>`;
export {
  e as default
};
//# sourceMappingURL=facebook-color.es.rJXe6Hu7.js.map
